// extracted by mini-css-extract-plugin
module.exports = {"square":"TheSquare_square_1jtT1"};